import { render, staticRenderFns } from "./VxCellButtons.vue?vue&type=template&id=153a53b2&scoped=true&"
import script from "./VxCellButtons.vue?vue&type=script&lang=js&"
export * from "./VxCellButtons.vue?vue&type=script&lang=js&"
import style0 from "./VxCellButtons.vue?vue&type=style&index=0&id=153a53b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "153a53b2",
  null
  
)

export default component.exports